import axios from '@/http/axios'
import Vue from 'vue'

// export const getClassListDate = (data) => {
//   return axios({
//     url: Vue.prototype.baseServer.liveClassServer + '/api/v1/user/live',
//     method: 'get',
//     params: data
//   })
// }


export const getUserHasLiveDates = (data) => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/api/v1/user/live',
    method: 'get',
    params: data
  })
}

export const getUserLiveInfos= (data) => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/api/v1/user/liveinfo',
    method: 'get',
    params: data
  })
}

// 获取课程
export const queryUserClasses = data => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/api/v1/user/class',
    method: 'get',
    params: data
  })
}

export const getUserClassRooms = data => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/api/v1/class/rooms',
    method: 'get',
    params: data
  })
}

// 获取课程下的直播
export const getToken = data => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/api/v1/enter-room',
    method: 'get',
    params: data
  })
}

export const getUserInfo = data => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/api/v1/user-info',
    method: 'get',
    params: data
  })
}


export const getUserGroups = data => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/api/v1/user/group',
    method: 'get',
    params: data
  })
}


export const getUserGroupMsg = data => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/api/v1/appgroupmsg',
    method: 'get',
    params: data
  })
}


export const updatePasswd = data => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/api/v1/passwd',
    method: 'post',
    data
  })
}


export const getPhoneCode = data => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/api/v1/user/mobile/auth-code',
    method: 'get',
    params: data
  })
}

export const updatePhone = data => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/api/v1/user/mobile',
    method: 'post',
    data
  })
}

export const updateNickName = data => {
  return axios({
    url: Vue.prototype.baseServer.liveClassServer + '/api/v1/user/nickname',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/liveServer.js